<template>
  <router-view></router-view>
  <ModalWait />
  <ModalNetworkError />
  <Overlay></Overlay>
</template>

<style></style>

<script>
import Overlay from "@/components/overlay.vue";
import ModalWait from "@/components/modal-wait.vue";
import ModalNetworkError from "@/components/modal-error.vue";
export default {
  name: 'App',
  components: {
    Overlay,
    ModalWait,
    ModalNetworkError
  }
};
</script>
